import { render, staticRenderFns } from "./ManagersTable.vue?vue&type=template&id=69aca61b&"
import script from "./ManagersTable.vue?vue&type=script&lang=js&"
export * from "./ManagersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports